import { render, staticRenderFns } from "./exchangeRate.vue?vue&type=template&id=0a2f76d3&scoped=true"
import script from "./exchangeRate.vue?vue&type=script&lang=js"
export * from "./exchangeRate.vue?vue&type=script&lang=js"
import style0 from "./exchangeRate.vue?vue&type=style&index=0&id=0a2f76d3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2f76d3",
  null
  
)

export default component.exports